import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { MsLoginServiceService } from '../../modules/login/service/ms-login-service.service';

/** Auth guard */
@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
	/**
	 * Constructor
	 *
	 * @param router router
	 * @param MsLoginService
	 */
	constructor(
		private router: Router,
		private MsLoginService: MsLoginServiceService
	) {}

	/**
	 * Check if user can activate route
	 *
	 * @param route
	 * @param state
	 */
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		if (!this.MsLoginService.getLoginStatus()) {
			this.router.navigate(['login']);
		}
		return this.MsLoginService.getLoginStatus();
	}

	/**
	 * Check if user can activate child route
	 *
	 * @param route
	 * @param state
	 */
	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.canActivate(route, state);
	}
}
